interface IBaseJWTDecoded {
  exp: number;
  iat: number;
  sub: string;
}

export class JWTUtil {
  static decode<T>(token: string): T & IBaseJWTDecoded {
    const payload = token.split('.')[1];
    return JSON.parse(window.atob(payload));
  }

  static isExpired(token: string): boolean {
    const decoded = this.decode<IBaseJWTDecoded>(token);
    return (decoded.exp * 1000) < new Date().getTime();
  }
}